import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import flexible from './utils/flexible.js'
import "swiper/dist/css/swiper.css";
import "./assets/main.css";
import ElementUi from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import cookie from 'vue-cookie'
import axios from 'axios';
import xss from 'xss';

const NODE_ENV = process.env.NODE_ENV;
const baseURL = process.env.NODE_ENV == 'development' ? '' : Glob.baseUrl
// const baseURL = Glob.baseUrl
const instance = axios.create({
  baseURL: baseURL,
  withCredentials: true
})
instance.interceptors.request.use((config) => {
  // console.log(config)
  // if (config && config.data){
  //   for (let key in config.data) {
  //     console.log()
  //     if (config.data[key].indexOf('script') > -1 || config.data[key].indexOf('alert') > -1 || config.data[key].indexOf('javascript') > -1){
  //       return alert('输入值有不合法参数')
  //     }
  //   }
  // }
  config.headers.Authorization = cookie.get('token')
  if (window.localStorage.getItem('authCode')) {
    config.headers.sessionId = window.localStorage.getItem('authCode')
  }
  return config
  }, (error) => {
});
instance.interceptors.response.use((response) => {
  // 票务接口返回
  if (router.history.current.path.indexOf('ticket') > -1) {
    if (response.request.responseURL.indexOf('/jwt/member-token') > -1 || response.request.responseURL.indexOf('/advance-search') > -1) {
      return response
    }
    console.log(response)
    if (response.data.status == 40301) {
      // alert('请登录')
      // Vue.prototype.$message.warning('请登录');
      // location.href = `http://passport2.chaoxing.com/logout.html?refer=${location.origin}${location.pathname}#/ticket/login?museumCode=${router.app._route.query.museumCode}${router.app._route.query.id ? `&id=${router.app._route.query.id}` : ''}${router.app._route.query.code ? `&code=${router.app._route.query.code}` : ''}`
      router.push({path: '/ticket/login', query: router.app._route.query})
    } else if (!response.data.rel || response.data.status != 200){
      Vue.prototype.$message.error(response.data.data);
      // alert(response.data.data)
      return Promise.reject();
    } else {
      return response.data;
    }
  }
}, (error) => {
  console.log(error, 'error')
  if (error.response.status == 403 && router.history.current.path.indexOf('ticket') > -1) {
    // Vue.prototype.$message.warning('请登录')
    // location.href = `http://passport2.chaoxing.com/logout.html?refer=${location.origin}${location.pathname}#/ticket/login?museumCode=${router.app._route.query.museumCode}${router.app._route.query.id ? `&id=${router.app._route.query.id}` : ''}${router.app._route.query.code ? `&code=${router.app._route.query.code}` : ''}`
    router.push({path: '/ticket/login', query: router.app._route.query})
    return
  }
  Vue.prototype.$message.error(error.response.data.message);
  return error.response.data
});
Vue.prototype.$ajax = instance
Vue.prototype.$cookie = cookie;
Vue.prototype.Glob = Glob
Vue.prototype.xss = xss

Vue.config.productionTip = false
Vue.use(ElementUi)
flexible()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
